import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectTypeStoreActions,
  ProjectTypeStoreSelectors,
  ProjectTypeStoreReducer,
} from './index';
import { ProjectTypeDto } from '@cradua/data';

@Injectable()
export class ProjectTypeFacade {
  constructor(
    private store: Store<ProjectTypeStoreReducer.ProjectTypePartialState>
  ) {}

  projectTypeRecord$ = this.store.select(ProjectTypeStoreSelectors.getSelected);
  projectTypeRecordError$ = this.store.select(
    ProjectTypeStoreSelectors.getProjectTypeError
  );

  getselected() {
    return this.store.select(ProjectTypeStoreSelectors.getSelected);
  }

  get isLoadingProjectType() {
    this.store.dispatch(ProjectTypeStoreActions.loadProjectType());
    return this.store.select(ProjectTypeStoreSelectors.loadingProjectType);
  }

  get loadProjectType() {
    this.store.dispatch(ProjectTypeStoreActions.loadProjectType());
    return this.store.select(ProjectTypeStoreSelectors.getAllProjectType);
  }

  addProjectType(newProjectType: ProjectTypeDto[]) {
    this.store.dispatch(
      ProjectTypeStoreActions.addProjectType({ newProjectType })
    );
  }

  updateProjectType(updateProjectType: ProjectTypeDto[]) {
    this.store.dispatch(
      ProjectTypeStoreActions.updateProjectType({ updateProjectType })
    );
  }

  removeProjectType(ids: string[]) {
    this.store.dispatch(ProjectTypeStoreActions.removeProjectType({ ids }));
  }
}
